import { get } from 'lodash';
import {getConfig} from '../config/portal';
import {getBoatsConstants} from '../constants/boats';

export const getPortalDefaultCountry = () => get(getConfig(), 'country');

const isFilterEnabledForPortal = (filter) => {
  const portalFiltersConfig = get(getConfig(), 'pages.searchResults.facets', []);
  const filterConfig = portalFiltersConfig.find((config) => config.name === filter);
  return Boolean(filterConfig);
};

export const portalHasCountryFilter = () => {
  return isFilterEnabledForPortal('country');
};

export const countryHasRegionFilter = (country) => {
  const filterConfig = get(getBoatsConstants().LOCATION_FILTERS_CONFIG, `${country.toUpperCase()}.grouping`, false);
  return filterConfig && isFilterEnabledForPortal('region');
};

export const isRegionFilterEnabled = (selectedCountry) => {
  const country = portalHasCountryFilter() ? selectedCountry : getPortalDefaultCountry();
  return countryHasRegionFilter(country);
};

export const countryHasSubdivisionFilter = (country) => {
  const filterConfig = get(getBoatsConstants().LOCATION_FILTERS_CONFIG, `${country.toUpperCase()}.subdivision`, false);
  return filterConfig && isFilterEnabledForPortal('subdivision');
};

export const isSubdivisionFilterEnabled = (selectedCountry, selectedRegion) => {
  const country = portalHasCountryFilter() ? selectedCountry : getPortalDefaultCountry();
  const isRegionRequired = countryHasRegionFilter(country);
  const countryHasTheFilter = countryHasSubdivisionFilter(country);
  return isRegionRequired ? Boolean(selectedRegion) && countryHasTheFilter : countryHasTheFilter;
};

export const countryHasCityFilter = (country) => {
  const filterConfig = get(getBoatsConstants().LOCATION_FILTERS_CONFIG, `${country.toUpperCase()}.city`, false);
  return filterConfig && isFilterEnabledForPortal('city');
};

export const isCityFilterEnabled = (selectedCountry, selectedSubdivision) => {
  const country = portalHasCountryFilter() ? selectedCountry : getPortalDefaultCountry();
  const isSubdivisionRequired = countryHasSubdivisionFilter(country);
  const countryHasTheFilter = countryHasCityFilter(country);
  return isSubdivisionRequired ? Boolean(selectedSubdivision) && countryHasTheFilter : countryHasTheFilter;
};
